<template>
<div>
    接口测试
</div>
</template>

<script>
export default {
    name:"test",
    created(){
        var sif=this.$SIF;
        sif.login({
            params:{
                account:"17615819718",
                pass:"22222222",
                userType:"0"
            },
            succFun:function (params) {
                //   sif.getAllContract(function(result){
                //         // if(result.code==10000){
                //         // 	 that.$store.commit('SET_TOKEN', {token: result.token});
                //         // 	 that.$router.push('home');
                //         // }

                //     })
            }
        })

    }
}
</script>

<style>
</style>